import { EmptyObject } from '@reduxjs/toolkit';

export interface IAppleGoogleViewModel {
  getStripeKey: () => Promise<string>;
  processPaymentCancel: () => Promise<void>;
  processPaymentError: (error: any) => Promise<void>;
  processPaymentAction: (paymentMethodId: string, productId: number, email: string, productName?: string, paymentSystem?: string) => Promise<EmptyObject>;
}

export enum PAYMENT_SYSTEM {
  APPLE_PAY = 'applePay',
  GOOGLE_PAY = 'googlePay',
  BROWSER_SAVED_CARD = 'Browser-saved cards',
}
